const addGiftProductToCart = async (variantId, quantity) => {
    const url = '/cart/add.js';
    const data = { id: variantId, quantity: quantity, sections: ['mini-cart'] };

    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data)
        });

        if (!response.ok) { throw new Error('Network response was not ok ' + response.statusText); }

        const responseJson = await response.json();
        const cartResponse = await fetch(`${window.themeVariables.routes.cartUrl}.js`);
        const cartContent = await cartResponse.json();

        document.documentElement.dispatchEvent(new CustomEvent("cart:updated", {
            bubbles: true,
            detail: { cart: cartContent }
        }));

        cartContent["sections"] = responseJson["sections"];

        const miniCartStatus = document.querySelector('#mini-cart').getAttribute('open') === '';

        document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
            bubbles: true,
            detail: { cart: cartContent, openMiniCart: miniCartStatus }
        }));

        return true;
    } catch (error) {
        console.error('There was a problem with the fetch operation:', error);
        return false;
    }
};

const removeGiftProduct = async (variantId) => {
    const url = '/cart/update.js';
    const data = { id: variantId, quantity: 0, sections: ['mini-cart'] };

    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data)
        });

        if (!response.ok) { throw new Error('Network response was not ok ' + response.statusText); }

        const cart = await response.json();
        return true;
    } catch (error) {
        console.error('There was a problem with the fetch operation:', error);
        return false;
    }
};

// Set progress instantly — no slow animation from 0
function setProgressInstant(element) {
    if (!element) return;
    element.value = parseInt(element.dataset.value) || 0;
}

// Countdown — module-level flag so it survives across checkFreeGifts calls
let _countdownStarted = false;
let _countdownTimer = null;
let _timeLeft = 5 * 60;

function startCountdown() {
    if (_countdownStarted) return;
    _countdownStarted = true;

    const countdownElement = document.getElementById("countdown");
    const greenBox = document.getElementById("countdownBox");
    const redBox = document.getElementById("countdown_redBox");

    function updateCountdown() {
        const minutes = Math.floor(_timeLeft / 60);
        const seconds = _timeLeft % 60;
        if (countdownElement) {
            countdownElement.textContent =
                `${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
        }
        if (_timeLeft <= 0 && greenBox && redBox) {
            clearInterval(_countdownTimer);
            greenBox.style.display = "none";
            redBox.style.display = "flex";
        }
        _timeLeft--;
    }

    updateCountdown();
    _countdownTimer = setInterval(updateCountdown, 1000);
}

// Guard against re-entrant calls while a gift add/remove is in flight
let _giftOperationInProgress = false;

const checkFreeGifts = (html) => {
    const counterInput = document.getElementById("counterInput");
    setProgressInstant(counterInput);

    startCountdown();

    if (_giftOperationInProgress) return;

    const freeGiftCircles = html.querySelectorAll('.rewardbar .rewardbar-freegift-circle');
    const cartProductItems = html.querySelectorAll('.drawer__content .line-item .product-item-meta__title');
    const activeCircle = Array.from(freeGiftCircles).find(circle => circle.classList.contains('active'));
    const dataProductValues = Array.from(freeGiftCircles).map(circle => circle.getAttribute('data-product')).filter(Boolean);

    if (activeCircle) {
        const productData = activeCircle.getAttribute('data-product');
        const matchingCartItem = Array.from(cartProductItems).find(item =>
            item.getAttribute('data-variant') === productData
        );

        if (!matchingCartItem) {
            _giftOperationInProgress = true;
            addGiftProductToCart(productData, 1).finally(() => {
                _giftOperationInProgress = false;
            });
        }
    } else {
        const matchingCartItems = Array.from(cartProductItems).filter(item =>
            dataProductValues.includes(item.getAttribute('data-variant'))
        );

        if (matchingCartItems.length > 0) {
            _giftOperationInProgress = true;
            matchingCartItems.forEach(item => {
                item.closest('.line-item__info').querySelector('.line-item__remove-button').click();
            });
            setTimeout(() => { _giftOperationInProgress = false; }, 1000);
        }
    }
};
